export default "__VITE_ASSET__3e42d60d__"